import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

interface FormSectionProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
}

export function FormSection({ title, children }: FormSectionProps) {
  return (
    <Box mb={4}>
      <SectionHeader title={title} />
      <Stack spacing={4}>{children}</Stack>
    </Box>
  );
}

interface SectionHeaderProps {
  title: string | React.ReactNode;
  description?: string;
  showDivider?: boolean;
}

export function SectionHeader({ title, description, showDivider = false }: SectionHeaderProps) {
  return (
    <Box sx={{ mt: 0, mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 0.5,
          }}
        >
          {description}
        </Typography>
      )}

      {showDivider && (
        <Divider
          sx={{
            mt: 2,
          }}
        />
      )}
    </Box>
  );
}
